// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2759": "7d94a73dfccc","494": "4077578422d4","6046": "9e6d8f2d757b","6563": "c118f70d3cdb",}[chunkId] + ".css"
}